'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { prefixPath } from '@/config'

exports.default = {
  data: function data() {
    return {
      anmitaDelay: 2000,
      anmiationObserver: null,
      fileUrl: 'api-gateway/api-uum/file/downloadFile'
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.findCurrentComponentAllNeedAnimationDom();
    }, 16);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.anmiationObserver) {
      this.anmiationObserver.disconnect();
    }
  },

  methods: {
    //请求接口后需要给新的元素添加监听
    addObserverForRequest: function addObserverForRequest() {
      var _this2 = this;

      setTimeout(function () {
        _this2.findCurrentComponentAllNeedAnimationDom();
      }, 20);
    },

    //找到所有需要动画的元素
    findCurrentComponentAllNeedAnimationDom: function findCurrentComponentAllNeedAnimationDom() {
      var _this3 = this;

      (0, _keys2.default)(this.$refs).forEach(function (ref) {
        if (ref.endsWith('Ref') && _this3.$refs[ref]) {
          //从下而上
          var elements = _this3.$refs[ref].querySelectorAll('.iv-animation-start');
          _this3.addObserver(elements);
          //次第显示
          var orderEle = _this3.$refs[ref].querySelectorAll('.iv-home-communist-op');
          _this3.addObserver(orderEle);
        }
      });
    },

    // 确保元素在视口中，可以使用IntersectionObserver
    addObserver: function addObserver(elements) {
      var _this4 = this;

      if (!this.anmiationObserver) {
        this.anmiationObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (entry.target.classList.contains('iv-home-communist-op')) {
                var curClass = entry.target.getAttribute('data-class');
                var timeDuration = curClass.slice(-1);
                setTimeout(function () {
                  entry.target.classList.add(curClass);
                }, Number(timeDuration) * 1000);
              } else {
                entry.target.classList.add('iv-animation');
              }
              _this4.anmiationObserver.unobserve(entry.target);
            }
          });
        });
      }
      for (var i = 0; i < elements.length; i++) {
        this.anmiationObserver.observe(elements[i]);
      }
    },
    delayCall: function delayCall(callback, time) {
      setTimeout(function () {
        callback();
      }, time);
    }
  }
};